import { render, staticRenderFns } from "./OrderStatusFormattedField.vue?vue&type=template&id=601d5439&"
import script from "./OrderStatusFormattedField.vue?vue&type=script&lang=js&"
export * from "./OrderStatusFormattedField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('601d5439')) {
      api.createRecord('601d5439', component.options)
    } else {
      api.reload('601d5439', component.options)
    }
    module.hot.accept("./OrderStatusFormattedField.vue?vue&type=template&id=601d5439&", function () {
      api.rerender('601d5439', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/orders/fields/OrderStatusFormattedField.vue"
export default component.exports